import { apiClient } from "./authService";

export interface UnitSettings {
  id: string;
  unit_id: string;
  open_time: string;
  close_time: string;
  slot_duration_minutes: number;
  public_match_quit_window_hours: number;

  reminder_24h_template: string;
  reminder_2h_template: string;
  create_template: string;
  cancel_template: string;
  update_template: string;
}

export const getUnitSettings = async (unitId: string): Promise<UnitSettings> => {
  const res = await apiClient.get<UnitSettings>(`/unit-settings/${unitId}`);
  return res.data;
};

export const updateUnitSettings = async (
  unitId: string,
  payload: {
    openTime?: string;
    closeTime?: string;
    slotDurationMinutes?: number;
    publicMatchQuitWindowHours?: number;
    reminder24hTemplate?: string;
    reminder2hTemplate?: string;
    createTemplate?: string;
    cancelTemplate?: string;
    updateTemplate?: string;
  }
): Promise<UnitSettings> => {
  const res = await apiClient.put<UnitSettings>(`/unit-settings/${unitId}`, payload);
  return res.data;
};
